export default __webpack_public_path__ + "static/media/Math.3e069cbd.png";